import { render, staticRenderFns } from "./UpdateFeeModal.vue?vue&type=template&id=718a29b4&scoped=true&"
import script from "./UpdateFeeModal.vue?vue&type=script&lang=js&"
export * from "./UpdateFeeModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateFeeModal.vue?vue&type=style&index=0&id=718a29b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718a29b4",
  null
  
)

component.options.__file = "UpdateFeeModal.vue"
export default component.exports